export const formatError: any = (error: any) => {
  if (!error) return null

  if (typeof error === 'string') {
    return prettifyKnownErrors(error)
  }

  if (Array.isArray(error)) {
    return error.map(formatError).join(' ')
  }

  if (typeof error === 'object') {
    return prettifyKnownErrors(error?.message)
  }

  return 'Unknown error'
}

const prettifyKnownErrors = (error: string) => {
  switch (error) {
    case 'Firebase: Error (auth/email-already-in-use).':
      return 'Sorry, that email is already in use.'
    case 'Firebase: Error (auth/wrong-password).':
      return 'Sorry, those credentials are incorrect.'
    case 'Firebase: Error (auth/user-not-found).':
      return 'Sorry, no account found.'
    case 'Firebase: Error (auth/invalid-email).':
      return 'Sorry, that email is invalid.'
    case 'Firebase: Error (auth/weak-password).':
      return 'Sorry, that password is too weak.'
    case 'Firebase: Error (auth/user-disabled).':
      return 'Sorry, your account has been disabled.'
    case 'Firebase: Error (auth/requires-recent-login).':
      return 'Sorry, you need to login again.'
    case 'Firebase: Error (auth/too-many-requests).':
      return 'Sorry, you have made too many requests.'
    case 'Firebase: Error (auth/user-token-expired).':
      return 'Sorry, your login has expired.'
    case 'Firebase: Error (auth/invalid-credential).':
      return 'Sorry, those credentials are invalid.'
    case 'Firebase: Error (auth/operation-not-allowed).':
      return 'Sorry, that operation is not allowed.'
    case 'Firebase: Error (auth/invalid-verification-code).':
      return 'Sorry, that verification code is invalid.'
    case 'Firebase: Error (auth/invalid-verification-id).':
      return 'Sorry, that verification ID is invalid.'
    case 'Firebase: Error (auth/missing-verification-code).':
      return 'Sorry, that verification code is missing.'
    case 'Firebase: Error (auth/missing-verification-id).':
      return 'Sorry, that verification ID is missing.'
    case 'Firebase: Error (auth/account-exists-with-different-credential).':
      return 'Sorry, that account already exists.'
    default:
      return error
  }
}
